import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcNavigateDirectiveModule } from '@datachain/ui-sdk/directives';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { MetadataListComponent } from './components/metadata-list/metadata-list.component';
import {
	MetadataEffects,
	metadataReducer,
	MetadataSelector,
	MetadataState,
} from './store';

@NgModule({
	declarations: [MetadataListComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		DxDataGridModule,
		NgOptimizedImage,
		FormsModule,
		StoreModule.forFeature(MetadataState.key, metadataReducer),
		EffectsModule.forFeature([MetadataEffects]),
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcNavigateDirectiveModule,
	],
	providers: [MetadataSelector],
})
export class MetadataModule {
	public constructor(private readonly injector: Injector) {
		const metadataListCmpElement = createCustomElement(MetadataListComponent, {
			injector,
		});
		customElements.define('app-metadata-list', metadataListCmpElement);
	}
}
